import React from "react";

const Warning = () => (
  <dl className="important-note">
    <dt>WARNING:</dt>
    <dd>
      {[
        "If a material fact is not disclosed in this proposal, any policy issued may not be valid. ",
        "If you are in doubt as to whether a fact is material, you are advised to disclose it. This ",
        "includes any information that you may have provided to the Financial Services ",
        "Consultant(s)/ Insurance Representative(s) but was not included in the proposal. Please ",
        "check to ensure you are fully satisfied with the information declared in this proposal. ",
        "Additionally and without prejudice to the parties' rights and obligations whether under ",
        "law or otherwise, you must continue to disclose any and all material facts that may arise ",
        "or which have changed from the information you had provided.",
      ].join("")}
    </dd>
  </dl>
);

export default Warning;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/Warning.js